import React from 'react';
import { AnnouncementBanner } from '../components/AnnouncementBanner';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { BonusSection } from '../components/BonusSection';
import { ForYouSection } from '../components/ForYouSection';
import { OfferSection } from '../components/OfferSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { LegalFooter } from '../components/LegalFooter';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-beige-sand font-body text-text-body overflow-x-hidden" data-id="element-294">
      <AnnouncementBanner data-id="element-295" />
      <HeroSection data-id="element-296" />
      <ProblemSection data-id="element-297" />
      <SolutionSection data-id="element-298" />
      <ForYouSection data-id="element-299" />
      <ContentSection data-id="element-300" />
      <BonusSection data-id="element-301" />
      <OfferSection data-id="element-302" />
      <FinalCTASection data-id="element-303" />
      <FAQSection data-id="element-304" />
      <LegalFooter data-id="element-305" />
      <PurchasePopup data-id="element-306" />
    </main>;
}